/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import React, { useContext, useEffect } from 'react';
import { Box, Card, CardContent, Typography, Modal, Grid, Button } from '@mui/material';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import modalIcon from '../../images/normaltriangle.svg';
import modalAlert from '../../images/redTriangle.svg';

import { SaveContinueModalStyles as classes } from './SaveContinueModalStyles';

const SaveContinueModal = (props) => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { saveLaterVal, isModalSave, setIsModalSave, isDuplicate, setIsDuplicate } =
    leadGenerationContext;
  const [open, setOpen] = React.useState(true);

  const handleClose = async () => {
    leadGenerationContext.setSaveLaterVal([]);
    setIsDuplicate(false);
    setIsModalSave(false);
  };

  useEffect(() => {
    isModalSave ? setOpen(true) : setOpen(false);
  }, [isModalSave]);
  return (
    <Modal
      sx={classes.backdrop}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(233, 233, 235, 0.78)',
        },
      }}
      open={open}
      role="region"
      aria-describedby="dialog1BusinessDesc dialog2BusinessDesc"
    >
      <div style={{ outline: 'none' }} id="modalSave">
        <Card sx={classes.root}>
          <CardContent sx={classes.card_content}>
            <div>
              <img
                src={isDuplicate ? modalAlert : modalIcon}
                alt="modal icon"
                height="72px"
                width="72px"
              />
            </div>
            {isDuplicate ? (
              <Typography
                style={{
                  textAlign: 'center',
                  color: '#D71721',
                  fontFamily: 'Arial',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '120%',
                }}
                sx={classes.text_One_Space}
              >
                {t(
                  'Application cannot be saved. There is already a saved application with the given information.',
                  {
                    defaultValue:
                      'Application cannot be saved. There is already a saved application with the given information.',
                  }
                )}
              </Typography>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                }}
              >
                <Typography
                  sx={[classes.textOneStyle, classes.text_One_Space]}
                  id="dialog1BusinessDesc"
                >
                  {t('Your ', {
                    defaultValue: 'Your ',
                  })}
                  <span>
                    {saveLaterVal.length === 2 ? (
                      <>
                        <Box component="span" sx={classes.textBalckStyle}>
                          {t('date of birth', {
                            defaultValue: 'date of birth',
                          })}
                        </Box>
                        {t(' and ', {
                          defaultValue: ' and ',
                        })}
                        <Box component="span" sx={classes.textBalckStyle}>
                          {t('last name', {
                            defaultValue: 'last name',
                          })}
                        </Box>
                      </>
                    ) : (
                      <Box component="span" sx={classes.textBalckStyle}>
                        {t(saveLaterVal, {
                          defaultValue: saveLaterVal,
                        })}
                      </Box>
                    )}
                  </span>

                  {t(' has been updated as per your uploaded Id.', {
                    defaultValue: ' has been updated as per your uploaded Id.',
                  })}
                </Typography>
              </div>
            )}

            <Grid
              container
              style={
                isDuplicate
                  ? {
                      display: 'flex',
                      marginBottom: '31px',
                      justifyContent: 'center',
                    }
                  : {
                      display: 'flex',
                      marginBottom: '51px',
                      justifyContent: 'center',
                    }
              }
              sx={classes.btn_Space}
            >
              <Grid size={{ xs: 12 }}>
                <Button
                  disableFocusRipple
                  tabIndex="0"
                  variant="outlined"
                  sx={classes.saveAndExit_Close}
                  classes={{
                    disabled: classes.save_disabled_button,
                  }}
                  data-testid="CloseTryButtonInBusinessModal"
                  onClick={handleClose}
                >
                  {isDuplicate
                    ? t('Back', { defaultValue: 'Back' })
                    : t('Continue', { defaultValue: 'Continue' })}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </Modal>
  );
};
export default withRouter(SaveContinueModal);
